import { render } from "./ChangeValuesRecords.vue?vue&type=template&id=a6953344&ts=true"
import script from "./ChangeValuesRecords.vue?vue&type=script&lang=ts"
export * from "./ChangeValuesRecords.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__